import fetch, { Response } from 'node-fetch';
import * as qslib from 'qs';

interface SapAuthTokenResponse {
  response: Response;
  body?: { access_token: string; token_type: string };
  errors?: { message: string }[];
}

export const getSapAuthToken = async (): Promise<SapAuthTokenResponse> => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  const data = {
    client_id: `${process.env.REACT_APP_SAP_SB_CLIENT_ID}`,
    client_secret: `${process.env.REACT_APP_SAP_SB_CLIENT_SECRET}`,
    grant_type: 'client_credentials',
  };

  const URL = `${process.env.REACT_APP_SAP_SB_AUTH_TOKEN_URL}`;

  const authPayload = {
    headers,
    method: 'POST',
    body: qslib.stringify(data),
  };

  const response = await fetch(URL, authPayload);
  const body = await response.json();

  if (response.status === 200) {
    return {
      response,
      body,
    };
  } else {
    return {
      response,
      errors: [{ message: `${body?.error} : ${body?.error_description}` }],
    };
  }
};
